var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Datagrid, DateField } from 'react-admin';
import { AuthorField } from '../AuthorField';
import { ActionField } from '../ActionField';
import { ResourceField } from '../ResourceField';
import { useGetActionLink } from '../useGetActionLink';
export var EventDatagrid = function (props) {
    var authorResource = props.authorResource, rest = __rest(props, ["authorResource"]);
    var getActionLink = useGetActionLink();
    var handleRowClick = function (id, basePath, record) {
        return getActionLink(record);
    };
    return (React.createElement(Datagrid, __assign({ rowClick: handleRowClick }, rest),
        React.createElement(DateField, { source: "date" }),
        React.createElement(ResourceField, { source: "resource" }),
        React.createElement(AuthorField, { authorResource: authorResource, source: "author" }),
        React.createElement(ActionField, { source: "action" })));
};
